import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EyeOffIcon from '@heroicons/react/outline/EyeOffIcon';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { useI18n } from '../i18n';
export const PostHiddenIndicator = ({ isReply = false, }) => {
    const intl = useI18n();
    return (_jsxs(Tooltip, { children: [_jsxs(Tooltip.Trigger, { className: "inline-flex self-center", children: [_jsx(EyeOffIcon, { className: "relative", style: { width: '1em', height: '1em', top: '0.125em' } }, void 0), "\u00A0"] }, void 0), _jsx(Tooltip.Panel, { children: isReply
                    ? intl.$t({
                        id: 'Post.PostHiddenIndicator.ReplyIndicator',
                        defaultMessage: 'People won’t see this reply. It will still be available for the author, admins, and moderators.',
                    })
                    : intl.$t({
                        id: 'Post.PostHiddenIndicator.PostIndicator',
                        defaultMessage: 'People won’t see this post in their Feed. It will still be available for the author and in search results.',
                    }) }, void 0)] }, void 0));
};
//# sourceMappingURL=PostHiddenIndicator.js.map